import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import AuthenticationGuideCheckStatus from '@app/store/contract-authentication/AuthenticationGuideCheckStatus';

export enum VerificationPreVerifyStatus {
  CORRECT = 'CORRECT',
  INCORRECT = 'INCORRECT',
}

interface DocumentsParticipantVerificationPreVerifyResponse {
  status: VerificationPreVerifyStatus;
}

const convertToNewRequest = ({
  answer,
  authType,
  authGuide,
}: {
  answer: string;
  authType: 'D_CERT' | 'MOBILE_IDENTIFICATION';
  authGuide: string;
}) => {
  return {
    methodType: authType,
    passValue: authGuide + answer,
  };
};

const convertToDeprecatedAuthsGuideCheckResponse = (
  status: VerificationPreVerifyStatus
): AuthenticationGuideCheckStatus => {
  return AuthenticationGuideCheckStatus[status];
};

/**
 * POST 인증 가이드 확인
 *
 * @deprecated This API is forwarded. Due to the path, request and response is changed in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#b01d31ed0c53402580d58ae5da724d22
 */
export function postDocumentsParticipantsAuthsGuideCheck({
  workspaceId,
  documentId,
  participantId,
  ...request
}: {
  workspaceId: string;
  answer: string;
  authGuide: string;
  authType: 'D_CERT' | 'MOBILE_IDENTIFICATION';
  authenticationId: string;
  documentId: string;
  participantId: string;
}): Promise<AuthenticationGuideCheckStatus> {
  const params = convertToNewRequest(request);

  return requestApi<DocumentsParticipantVerificationPreVerifyResponse>({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/${participantId}/verification/pre-verify`
    ),
    method: 'POST',
    data: {
      methodType: params.methodType,
      passValue: params.passValue,
    },
    credentials: true,
  }).then((response) => convertToDeprecatedAuthsGuideCheckResponse(response.data.status));
}
